/**
 * In-place Editor events defined here.
 */
/** @hidden */
export var render = 'render';
/** @hidden */
export var update = 'update';
/** @hidden */
export var destroy = 'destroy';
/** @hidden */
export var setFocus = 'set-focus';
/** @hidden */
export var accessValue = 'access-value';
/** @hidden */
export var destroyModules = 'destroy-modules';
/** @hidden */
export var showPopup = 'show-popup';
